import { GlobalOutlined } from "@ant-design/icons";
import { Form, Select } from "antd";
import React from "react";

const LANGS = [
    { value: "English", label: "English" },
    { value: "Hindi", label: "हिन्दी" },
    { value: "Normalized_Hindi", label: "Normalized हिन्दी" },
    { value: "Marathi", label: "मराठी" },
    { value: "Bengali", label: "বাংলা" },
    { value: "Telugu", label: "తెలుగు" },
    { value: "Tamil", label: "தமிழ்" },
    { value: "Urdu", label: "اردو" },
    { value: "Gujarati", label: "ગુજરાતી" },
    { value: "Kannada", label: "ಕನ್ನಡ" },
    { value: "Odia", label: "ଓଡ଼ିଆ" },
    { value: "Punjabi", label: "ਪੰਜਾਬੀ" },
    { value: "Malayalam", label: "മലയാളം" },
    { value: "Assamese", label: "অসমীয়া" },
    { value: "Maithili", label: "मैथिली" },
    { value: "Santali", label: "ᱥᱟᱱᱛᱟᱲᱤ" },
    { value: "Kashmiri", label: "كٲشُر / कश्मीरी" },
    { value: "Nepali", label: "नेपाली" },
    { value: "Konkani", label: "कोंकणी" },
    { value: "Dogri", label: "डोगरी" },
    { value: "Sindhi", label: "सिन्धी / سنڌي" },
    { value: "Manipuri", label: "ꯃꯅꯤꯄꯨꯔꯤ" },
    { value: "Bodo", label: "बड़ो" },
    { value: "Sanskrit", label: "संस्कृतम्" },
];

function LanguageDD({
    value,
    onChange,
    loading = false,
    minimal = false,
    width = 200,
}) {
    const element = (
        <Select
            showSearch
            placeholder="Select Language"
            value={value || "English"}
            onChange={onChange}
            options={LANGS}
            style={{ width: width }}
            prefix={<GlobalOutlined style={{ marginRight: "5px" }} />}
            optionRender={(option) => (
                <span>
                    {option.label}{" "}
                    {option.value !== "English" && (
                        <span style={{ color: "gray" }}>({option.value})</span>
                    )}
                </span>
            )}
            loading={loading}
            disabled={loading}
        />
    );

    if (minimal) {
        return element;
    }
    return (
        <div style={{ marginTop: "10px" }}>
            <Form layout="vertical">
                <Form.Item label="Translate to">{element}</Form.Item>
            </Form>
        </div>
    );
}

export default LanguageDD;
